(function () {
  'use strict';

  /* @ngdoc object
   * @name myMemberships.receivedLeads
   * @description
   *
   */
  angular
    .module('myMemberships.receivedLeads', [
      'ui.router'
    ]);
}());
